<template>
  <main id="login-page" class="login-page" v-if="$route.path === '/login'">
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessageLogin"
      :class="{ 'success-message': true, show: successMessageLogin }"
    >
      {{ successMessageLogin }}
    </p> -->

    <div id="login-form">
      <form class="login-form" @submit.prevent="normalAccess">
        <!-- Input email -->
        <input
          id="login-email"
          type="email"
          placeholder="Indirizzo email"
          v-model="email"
          autocomplete="email"
          required
        />

        <!-- Campo password con bottone/occhio -->
        <div class="password-field">
          <input
            :type="showPassword ? 'text' : 'password'"
            placeholder="Password"
            v-model="password"
            autocomplete="current-password"
            required
          />
          <!-- Occhio (o icona) per mostrare/nascondere la password -->
          <button
            type="button"
            class="toggle-password-button"
            @click="togglePassword"
          >
            <!-- Se showPassword è false, mostra icona occhio chiuso. Altrimenti, occhio aperto. -->
            <i v-if="!showPassword" class="fa-solid fa-eye-slash"></i>
            <i v-else class="fa-solid fa-eye"></i>
          </button>
        </div>

        <!-- Link “Ho dimenticato la password” -->
        <div class="forgot-password">
          <router-link to="/login/verify-email"
            >Ho dimenticato la password</router-link
          >
        </div>

        <!-- Bottone di login -->
        <button id="login-button" type="submit" :disabled="!email || !password">
          ACCEDI
        </button>
        <!-- <div class="hr-container">
          <span class="divider">oppure</span>
        </div>
        <button
          id="google-login-button"
          type="button"
          @click="socialLogin('google')"
        > -->
        <!-- <svg
            class="google-logo-svg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="20"
            height="20"
            aria-hidden="true"
          > -->
        <!-- blu -->
        <!-- <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21
         3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            /> -->
        <!-- verde -->
        <!-- <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71
         1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            /> -->
        <!-- giallo -->
        <!-- <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43
         8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            /> -->
        <!-- rosso -->
        <!-- <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1
         7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            /> -->
        <!-- bounding-box trasparente -->
        <!-- <path fill="none" d="M1 1h22v22H1z" /> -->
        <!-- </svg>
          Accedi con Google
        </button> -->
      </form>
    </div>
  </main>
  <router-view></router-view>
</template>

<script>
import { setAuth } from "../router";

// import axios from "@/axiosPlugin.mjs";
export default {
  name: "LoginPage",
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
      successMessageLogin: "",
      showPassword: false, // controlla se la password è visibile
    };
  },
  // created() {
  //   this.applyOAuthMessage(); // primo caricamento
  // },
  methods: {
    // applyOAuthMessage() {
    //   if (this._authToastShown) return;

    //   const { failure, cancel, reason } = this.$route.query || {};
    //   // console.log({ failure: failure, cancel: cancel, reason: reason });

    //   if (failure === "google") {
    //     //attualmente la reason per averla si dovrebbe creare una custom callback lato server che attualmente non ritengo necessaria
    //     const msg =
    //       reason === "not-allowed"
    //         ? "Accesso Google non autorizzato. Contatta l'amministratore."
    //         : "Accesso con Google non riuscito, l'utente non ha il permesso per accedere"; //--> quindi avremo sempre questo msg
    //     this.$toast.error(msg);
    //     this._authToastShown = true;
    //   } else if (cancel === "google") {
    //     this.$toast.info("Accesso con Google annullato.");
    //     this._authToastShown = true;
    //   }

    //   // (opzionale) pulisci la query dall'URL
    //   if (failure || cancel) {
    //     this.$nextTick(() => {
    //       this.$router.replace({ path: this.$route.path, query: {} });
    //     });
    //   }
    // },
    // async socialLogin(provider) {
    //   const base = process.env.VUE_APP_API_URL || "http://localhost:3000/api";
    //   try {
    //     if (provider === "google") {
    //       window.location.href = `${base}/auth/google`;
    //       return;
    //     }
    //   } catch (error) {
    //     console.error("Errore durante il login: ", error);
    //     //   // Se lo status è 401 => Credenziali non valide
    //     //   if (error.response?.status === 401) {
    //     //     this.errorMessage =
    //     //       error.response?.data.details || "Email/password non corrette!";
    //     //   } else {
    //     //     // altri errori generici
    //     const errorMessage =
    //       error.response?.data?.error || "Credenziali non valide";
    //     this.$toast.error(errorMessage);
    //     //   }
    //   }
    // },
    async normalAccess() {
      try {
        const payLoad = {
          email: this.email,
          password: this.password,
        };
        const response = await this.$axios.post("auth/login", payLoad);
        if (response.status === 200) {
          setAuth(true); // Aggiorna lo stato di autenticazione
          this.successMessageLogin = response.data.message;
          const successMessageLogin = response.data.message;
          this.$toast.success(successMessageLogin);
          setTimeout(() => {
            this.$router.push("/home");
          }, 2500);
        }
      } catch (error) {
        console.error("Errore durante il login: ", error);
        // Se lo status è 401 => Credenziali non valide
        if (error.response?.status === 401) {
          const errorMessage =
            error.response?.data.details || "Email/password non corrette!";
          this.$toast.error(errorMessage);
        } else {
          // altri errori generici
          const errorMessage =
            error.response?.data?.error || "Credenziali non valide";
          this.$toast.error(errorMessage);
        }
      }
    },
    togglePassword() {
      // Inverte lo stato showPassword
      this.showPassword = !this.showPassword;
    },
  },
  // watch: {
  //   "$route.query": {
  //     handler() {
  //       this.applyOAuthMessage();
  //     },
  //     immediate: false,
  //   },
  // },
};
</script>

<!-- Stesso file CSS (LoginPage.css) o un .vue con <style> -->
<style src="@/css/LoginPage.css"></style>
